module.exports = __webpack_public_path__ + "img/avatar.291d2e32.png";